import * as lodash from 'lodash'

export interface EntityTagsResponse {
  entity_type: string
  pkey: string
  tags: string[]
  account: number
  entity_pkey: string
}

export function uniqTags(tags: string[], caseSensitive = false) {
  return lodash.uniqBy(tags, (tag) => (caseSensitive ? tag : lodash.toLower(tag)))
}
